import { API_V4 } from "@/services/config/auth-axios";
class legalService {
  createCorporateAccount(payload) {
    return API_V4.post("corporate/accounts", payload);
  }
  getAccountsList() {
    return API_V4.get("corporate/accounts");
  }
  uploadTempFile(file, CA_ID) {
    return API_V4.post(`corporate/accounts/${CA_ID}/pre-register-files`, file, {
      headers: {
        "content-type": "multipart/form-data"
      }
    });
  }
  getTempFiles(CA_ID) {
    return API_V4.get(`corporate/accounts/${CA_ID}/pre-register-files`);
  }
  deleteTempFile(CA_ID, payload) {
    return API_V4.post(
      `corporate/accounts/${CA_ID}/pre-register-files/delete`,
      payload
    );
  }
  submitCorporateAccount(CA_ID) {
    return API_V4.post(`corporate/accounts/${CA_ID}/submit`, {
      submit: true
    });
  }
  getTerms() {
    return API_V4.get("/core/pages/cooperate-terms");
  }
  getGuide() {
    return API_V4.get("/core/pages/cooperate-guide");
  }
  getUserTerms() {
    return API_V4.get("/core/pages/cooperate-user-terms");
  }
  reviewLegalAccountByMember(CA_ID, payload) {
    return API_V4.post(`corporate/accounts/${CA_ID}/member-status`, payload);
  }
  accountDetailsWithMember(CA_ID) {
    return API_V4.get(`corporate/accounts/${CA_ID}`);
  }
  orderDetails(ref_number) {
    return API_V4.get(`orders/corporate-account/${ref_number}`);
  }
  reviewOrderByMember(refNum, payload) {
    return API_V4.post(`/orders/corporate-account/${refNum}/status`, payload);
  }
  needAcceptance(data) {
    return API_V4.get(
      `orders/corporate-account/need-acceptance/list?order_type=withdraw`,
      {
        params: data
      }
    );
  }
  getFileAttachment() {
    return API_V4.get("corporate/accounts/attachment");
  }
}

export default new legalService();
